import { pushDataLayer } from '../../../utils/datalayer'
import { ProductDataType } from '../common/AddToCart/types'

export const createDataLayerEcommerceProduct = (
  productData: Partial<ProductDataType> | undefined,
  stockLevelStatus?: string | ''
) => ({
  name: productData?.globalArticleName || '-',
  id: productData?.globalArticleCode || '-',
  price: productData?.price?.value || '-',
  brand: productData?.brand || '-',
  category: productData?.categoryIdentifier || '-',
  variant: productData?.nuance?.description || '-',
  dimension51: productData?.deviceVersion || 'n/a',
  dimension52: stockLevelStatus || '-',
  dimension54: 'n/a',
  dimension57: false,
  dimension58: productData?.pmiInternalProductCode,
  dimension59: 'n/a', // value will be provided in futures
  metric11: productData?.price?.value
})

export const pushDataLayerProductDetailsView = (product) => {
  pushDataLayer([
    {
      key: 'event',
      value: 'productDetailsView'
    },
    {
      key: 'ecommerce',
      value: {
        detail: {
          products: [product]
        }
      }
    }
  ])
}
